(function ( $ ) {
	
	"use strict";
	
	$(document).ready(function() {

      /*
		var scrollMagicController = new ScrollMagic.Controller();
      var $fixThisElements = $('[data-fix-this]');
      var offset = $('#wpadminbar').outerHeight(true);




      $fixThisElements.each(function() {

         var $this = $(this),
            triggerEl = $this.get(0),
            breakpoints = $this.data('fix-this');


         var fixThis = new ScrollMagic.Scene({
            triggerElement: triggerEl,
            triggerHook: 0
         }).setPin(triggerEl)
         //.addIndicators()
         .addTo(scrollMagicController);

          

         if (breakpoints.indexOf(Foundation.MediaQuery.current) === -1) {

            scrollMagicController.enabled(false);

         }

         $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){

            if (breakpoints.indexOf(newSize) === -1) {
               fixThis.enabled(false);
            } else {
               fixThis.enabled(false);
               fixThis.enabled(true);

            }

            $this.parent().show();

         });

      });

      */

	});


}( jQuery ));
